import {
    byteArrayToBase64,
    getAttachmentValues,
    stringToUtf8Bytes,
} from '@qdabra/infopath-attachments';
import { compose } from 'ramda';
import { setNil } from './qRules.node.helpers';

const qdimageAttributeXpathQrulesFilename =
    "@*[starts-with(local-name(), 'qRulesFilename')]";
const qdimageAttributeXpathQruleslink =
    "@*[starts-with(local-name(), 'qRulesLink')]";

const errorMissingRequiredAttributes =
    "Error: The required attributes are missing: 'qRulesFilename' and 'qRulesLink'.";

export function verifyRequiredAttributesExist(node) {
    if (
        !node.selectSingle(qdimageAttributeXpathQrulesFilename) ||
        !node.selectSingle(qdimageAttributeXpathQruleslink)
    ) {
        throw new Error(errorMissingRequiredAttributes);
    }
}

export async function clearFieldAndSetLinkAsync(node, fileName, url, clear) {
    if (clear) {
        setNil(node);
    }

    await node
        .selectSingle(qdimageAttributeXpathQrulesFilename)
        .setValueAsync(fileName);

    await node.selectSingle(qdimageAttributeXpathQruleslink).setValueAsync(url);
}

// DataSourceNode -> AttachmentValues
export const getBase64ValuesForNode = (node) =>
    node ? getAttachmentValues(node.value()) : null;

export const stringToBase64Raw = compose(byteArrayToBase64, stringToUtf8Bytes);
